// import { }
declare const site: server.dto.SiteData;

type Permissions = Exclude<keyof server.dto.Permissions, "canConfigureSystemSettings" | "canConfigureTemplates" | "canReview" | "canAccessAdminOne">;
export const getPermissions = (key: Permissions) => site.permissions[key];
